import { render, staticRenderFns } from "./ShareRouter.vue?vue&type=template&id=e579d3e6"
import script from "./ShareRouter.vue?vue&type=script&lang=js"
export * from "./ShareRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports